import React from "react";

function SummaryTour({ setStepsEnabled, setHomeScreenWalkThroughPopup }) {
  return (
    <div className="ContainerSubmitedSucess2 ">
      <div className="SubContainerSubmitedSucess innerContainerFlex">
        <div className="imageContainer">
          <img src="/gif/dcm_summary_guide.gif" alt="" />
        </div>
        <div className="rightContainer">
          <div className="studentLogos leftMargin">
            <div></div>
            <div>
              <img
                src="/StudentImg/BreathSchoolLogo.png"
                alt="icon"
                width={"30px"}
              ></img>
            </div>
          </div>
          <div className=" overallMarginHead" style={{ position: "relative" }}>
            <h4 className="textColor1"> Welcome to Summary Section</h4>
            <img style={{ width: "35px", height: "35px", position: "absolute", left: "87%", top: "195px", cursor: "pointer", zIndex: "999" }} src="./images/down_arrow.png" alt="arrowimag" onClick={() => {
              document.getElementById("last-paragraph").scrollIntoView({ behavior: "smooth" })
            }} />
          </div>

          <div className=" overallMargin">
            <p className="textColor2">
              1. Synchronize Classroom Learning at Home.
            </p>
            <hr></hr>
            <p className="textColor2">
              2. Access Every Lecture Key Overviews Anytime Anywhere.
            </p>
            <hr></hr>
            <p className="textColor2" >
              3. Improves Exam Preparation and Saves Time on Revision.
            </p>
            <hr></hr>
            <p className="textColor2">
              4. Boosts Retention and Understanding and Quick Overview of Key Concepts.
            </p>
            <hr></hr>
            <p className="textColor2" id="last-paragraph">
              5. Enhances Study Efficiency and Supports Faster Learning Process.
            </p>
            <hr></hr>
          </div>

          <div className="buttonsContainer">
            <button
              className="rightBtn"
              onClick={() => {
                setHomeScreenWalkThroughPopup(false);
                setStepsEnabled(true);
              }}
            >
              Take me to the product tour
            </button>
            <button
              id="summarytour"
              className="leftBtn"
              onClick={() => setHomeScreenWalkThroughPopup(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SummaryTour;
